export enum LaegekursusStatusEnum {
    ManglerHandling = 1,
    Udfyldt = 2,
    Godkendt = 3,
    Klarmeldt = 4
}
